export const MAX_DEFAULT_ZOOM_ZIP_AND_POINT = 18;
export const MAX_DEFAULT_ZOOM_OTHERS = 8;
export const MIN_THRESHOLD_TO_FIT_DATA = 0.05;
export const IMAGE_TILE_SIZE = 512;
export const CHOROPLETH_DIV_2_BOUNDARY_COLOR = 'rgba(255, 255, 255, 0.2)';
export const CHOROPLETH_DIV_1_BOUNDARY_COLOR = 'rgba(255, 255, 255, 0.3)';
export const BACKGROUND_WORLD_MAP_BOUNDARY_COLOR = 'rgba(255, 255, 255, 0.4)';
export const BACKGROUND_WORLD_MAP_FILL_COLOR = 'rgba(200, 200, 200, 0.6)';
export const MAX_CUSTOM_REGION_PREVIEW_REGIONS = 5000;
export const CUSTOM_REGION_PREVIEW_FILL_COLOR = '#fbbb8d';
export const CUSTOM_REGION_PREVIEW_STROKE_COLOR = '#000';
export const CUSTOM_REGION_PREVIEW_STROKE_WIDTH = 1;
export const CUSTOM_REGION_PREVIEW_LABEL_FONT_STYLE = '11px Optimo-Plain,Helvetica Neue,Helvetica,Arial,sans-serif';
export const CUSTOM_REGION_DEFAULT_LABEL_KEY = 'name';
export const GEOMETRY_TYPE = {
    POINT: 'Point',
    POLYGON: 'Polygon',
    MULTI_POLYGON: 'MultiPolygon',
    CIRCLE: 'Circle',
};
export const GEOMETRY_TYPE_PROTO = {
    POINT: 'POINT',
    POLYGON: 'POLYGON',
    MULTIPOLYGON: 'MULTI_POLYGON',
    CIRCLE: 'CIRCLE',
};
export const ALLOWED_WORLD_EXTENT = [-180, -60, 180, 80];
export const DEFAULT_CENTER = [0, 0];
export const DEFAULT_ZOOM = 2;
export const DEFAULT_MIN_ZOOM = 2;
export const DEFAULT_RESOLUTION = 10;
export const GEO_TILE_SET = {
    RASTER: 'RASTER',
    VECTOR: 'VECTOR',
};
export const VIEW_PROJECTION = 'EPSG:3857';
export const DATA_PROJECTION = 'EPSG:4326';
export const DEFAULT_BOUNDARY_COLOR = 'black';
export const DEFAULT_FILL_COLOR = 'transparent';
export const HOVERED_BOUNDARY_COLOR = 'black';
export const BOUNDARY_THICKNESS = 1;
export const HOVERED_BOUNDARY_THICKNESS = 2;
export const DEFAULT_BUBBLE_RADIUS = 8;
export const DEFAULT_BUBBLE_COLOR = 'red';
export const MIN_BUBBLE_RADIUS = 3;
export const ADMIN_DIV_0_AND_1_MAX_BUBBLE_SIZE = 15;
export const DEFAULT_MAX_BUBBLE_SIZE = 8;
export const GEO_AREA_OPACITY = 0.7;
export const BUBBLE_OPACITY = 0.7;
export const GEO_NEARBY_OBJECTS_LAYER_BOUNDARY_COLOR = 'rgba(246, 120, 120, 1.0)';
export const HEATMAP_GRADIENT_COLORS = [
    '#5768EB',
    '#8733DF',
    '#DE59D5',
    '#FF7033',
    '#FFCC00',
];
export const HEATMAP_WEIGHT_BASE = 0.12;
export const HEATMAP_WEIGHT_FRACTION = 0.28;
export const DARK_DATA_LABEL_FILL_COLOR = '#fff';
export const DARK_DATA_LABEL_STROKE_COLOR = '#444';
export const DATA_LABEL_FILL_COLOR = '#444';
export const DATA_LABEL_STROKE_COLOR = '#fff';
export const DATA_LABEL_STROKE_WIDTH = 0.5;
export const DATA_LABEL_FONT = '12px Verdana';
export const DATA_LABEL_LINE_HEIGHT = 15;
export const DATA_LABEL_AVG_CHAR_WIDTH = 8;
export const DEFAULT_GEO_DATA_NORMALIZER = (value) => {
    return `${value}`.trim().toLowerCase();
};
export const CUSTOM_REGION_FILE_CATEGORY = 'GEO_CUSTOM_REGION';
export const tileTypeStringPath = {
    LIGHT: 'charts.chartEditor.MAP_TILE.LIGHT',
    DARK: 'charts.chartEditor.MAP_TILE.DARK',
    OUTDOORS: 'charts.chartEditor.MAP_TILE.OUTDOORS',
    SATELLITE: 'charts.chartEditor.MAP_TILE.SATELLITE',
    SATELLITE_STREETS: 'charts.chartEditor.MAP_TILE.SATELLITE_STREETS',
    STREETS: 'charts.chartEditor.MAP_TILE.STREETS',
};
export const MAPBOX_CUSTOM_STYLE_IDS = {
    CN: {
        'light-v9': 'cl60ntmho000d14s8b4wbpjsa',
        'dark-v9': 'cl60nw0qw000915pkkfurmfdo',
        'outdoors-v9': 'cl60nzbcc000h14p5i9lm9yfi',
        'streets-v9': 'cl60o8c3v000i14nugk3q03a6',
        'satellite-streets-v9': 'cl60o19le000e15pbs2xfa0cr',
    },
    IN: {
        'light-v9': 'cl60nc9i0000e14nugbo9bw8w',
        'dark-v9': 'cl60nobb7004h15mu1u6l0030',
        'outdoors-v9': 'cl60npgvr000h15n41p7uittk',
        'streets-v9': 'cl60nt0e4000i16pf7lmuffgx',
        'satellite-streets-v9': 'cl60nsfge000q14n0h3v909gf',
    },
    JP: {
        'light-v9': 'cl60nulj2000714mmormrofnh',
        'dark-v9': 'cl60nwz9a000414p3km6194r4',
        'outdoors-v9': 'cl60o09pp000j14pat4280wjp',
        'streets-v9': 'cl60o8zzx000k16pfqwuugedj',
        'satellite-streets-v9': 'cl60o1uro000f15s0vv4da7sh',
    },
    US: {
        'light-v9': 'cl60np2ke000g16pfngt4fhjg',
        'dark-v9': 'cl60nonzl000g14nu4vb0kd90',
        'outdoors-v9': 'cl60nrceb000c14nviutpfm08',
        'streets-v9': 'cl60ntb1y000h14nu6kccllk4',
        'satellite-streets-v9': 'cl60nspyb004i15muvzs2dprt',
    },
};
export const GEO_3D_PROJECTION_TYPES = {
    GLOBE: 'GLOBE',
    PERSPECTIVE_PLANE: 'PERSPECTIVE_PLANE',
    MAP: 'MAP',
};
export const GEO_TILE_SOURCE_IDS = {
    THOUGHTSPOT_LOCAL: 'THOUGHTSPOT_LOCAL',
    MAPBOX: 'MAPBOX',
};
export const GEO_TILE_TYPES = {
    MAPBOX: {
        LIGHT: 'light-v9',
        DARK: 'dark-v9',
        OUTDOORS: 'outdoors-v9',
        STREETS: 'streets-v9',
        SATELLITE: 'satellite-v9',
        SATELLITE_STREETS: 'satellite-streets-v9',
    },
};
export const GEO_TILE_LAYER_TYPE = {
    MAPBOX: {
        'light-v9': 'VECTOR',
        'dark-v9': 'VECTOR',
        'outdoors-v9': 'VECTOR',
        'streets-v9': 'VECTOR',
        'satellite-v9': 'RASTER',
        'satellite-streets-v9': 'RASTER',
    },
};
export const GEO_MAP_THEME = {
    DARK: 'DARK',
    LIGHT: 'LIGHT',
};
export const MAPBOX_TILE_THEME_MAP = {
    [GEO_TILE_TYPES.MAPBOX.LIGHT]: GEO_MAP_THEME.LIGHT,
    [GEO_TILE_TYPES.MAPBOX.DARK]: GEO_MAP_THEME.DARK,
    [GEO_TILE_TYPES.MAPBOX.OUTDOORS]: GEO_MAP_THEME.LIGHT,
    [GEO_TILE_TYPES.MAPBOX.STREETS]: GEO_MAP_THEME.LIGHT,
    [GEO_TILE_TYPES.MAPBOX.SATELLITE]: GEO_MAP_THEME.DARK,
    [GEO_TILE_TYPES.MAPBOX.SATELLITE_STREETS]: GEO_MAP_THEME.DARK,
};
export const CUSTOM_CONTAINER_CLASS_NAME = {
    [GEO_MAP_THEME.DARK]: 'dark-map',
};
export const GEO_TILE_URLS = {
    THOUGHTSPOT_LOCAL: '/maptiles/{z}/{x}/{y}.jpg',
    MAPBOX: 'https://api.mapbox.com/styles/v1/mapbox/{tileType}/tiles/{z}/{x}/{y}?' +
        'access_token={access_token}',
    MAPBOX_WITH_BOUNDARY: 'https://api.mapbox.com/styles/v1/thoughtspot/{style_id}/tiles/256/{z}/{x}/{y}@2x?access_token={access_token}',
};
export const GEO_STYLE_URLS = {
    MAPBOX: 'mapbox://styles/mapbox/{tileType}',
    MAPBOX_CUSTOM: 'mapbox://styles/thoughtspot/{style_id}',
};
export const GEO_TILE_ATTRIBUTIONS = {
    MAPBOX: '<a target="_blank" href="https://www.mapbox.com/about/maps"> \
            <img style="height:1em;" src="/resources/img/mapbox-logo-black.png"/> \
        </a> \
        © <a target="_blank" href="https://www.mapbox.com/about/maps">Mapbox</a> \
        © <a target="_blank" href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> \
        <strong> \
            <a href="https://www.mapbox.com/map-feedback" target="_blank">Improve this map</a> \
        </strong>',
};
export const GEO_TILE_MAX_ZOOM = {
    THOUGHTSPOT_LOCAL: 11,
    MAPBOX: 18,
};
export const CUSTOM_REGION_FILE_FETCH_ENPOINT = '/callosum/v1/file/getfile';
export const DEFAULT_FEATURE_READ_BATCH_SIZE = 1000;
export const DEFAULT_MAX_REGION_NAMES_TO_LIST = 1000;
export const CHART_ID_PLACEHOLER = 'CHART_ID_HERE';
export const PRINT_MODE_ATTRIBUTION_ID = `print-mode-attribution-${CHART_ID_PLACEHOLER}`;
//# sourceMappingURL=geo-constants.js.map